import { render, staticRenderFns } from "./Nudge.vue?vue&type=template&id=9ca7b766&scoped=true&"
import script from "./Nudge.vue?vue&type=script&lang=js&"
export * from "./Nudge.vue?vue&type=script&lang=js&"
import style0 from "./Nudge.vue?vue&type=style&index=0&id=9ca7b766&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ca7b766",
  null
  
)

export default component.exports